import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar Seleção", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_consulta_produtos = _resolveComponent("consulta-produtos")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: 1300,
    "wrap-class-name": "ss-modal-cadastros",
    title: _ctx.state.titulo,
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_consulta_produtos, {
        empresa: _ctx.state.empresa,
        "tipo-selecao": _ctx.props.tipoSelecao,
        "pre-selecao": _ctx.props.preSelecao,
        "codigos-selecionados": _ctx.state.codigosSelecionados,
        "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.codigosSelecionados) = $event)),
        produtos: _ctx.state.produtos,
        "onUpdate:produtos": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.produtos) = $event))
      }, null, 8, ["empresa", "tipo-selecao", "pre-selecao", "codigos-selecionados", "produtos"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}